import _taggedTemplateLiteral from "/home/jenkins/workspace/terra.b2c.webui.register_staging/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n    font-weight: ", ";\n    text-align: left;\n\n    min-height: 80px;\n\n    margin: 0;\n    font-size: 14px;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n    font-weight: ", ";\n\n    font-size: 16px;\n    margin: 0;\n    margin-bottom: 5px;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: center;\n\n    ", ";\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    ::after {\n        content: ' ';\n        position: absolute;\n        width: 10px;\n        height: 10px;\n        top: -24px;\n        border-bottom: 3px solid #003a3b;\n        min-width: 300px;\n    }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    display: flex;\n\n    ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from 'styled-components';
import { Text, H4 } from '../../Atoms/Typography';
export var TimeLineWrapper = styled.div(_templateObject(), function (_ref) {
  var orientation = _ref.orientation;
  return orientation === 'vertical' ? "\n            flex-direction: column;\n            position: relative;\n            width: auto;\n            margin: 0 auto;\n            overflow: hidden;\n\n            ::after{\n                content: \"\";\n                position: absolute;\n                width: 0px;\n                background-color: red;\n                top: 0;\n                bottom: 0;\n                left: 50%;\n                margin-left: -3px;\n            }\n            " : "\n            position: relative;\n            overflow-x: auto;\n            -ms-overflow-style: none;  /* IE and Edge */\n            scrollbar-width: none;  /* Firefox */            \n\n            ::-webkit-scrollbar {\n                display: none;\n            }\n\n            align-items: center;\n            justify-content: center;\n            flex-direction: row;\n            flex-wrap: unset;\n\n            height: 200px;\n            min-height: 200px;\n\n        ";
});
export var Right = styled.div(_templateObject2());
export var TimeLineItem = styled.div(_templateObject3(), function (_ref2) {
  var orientation = _ref2.orientation;
  return orientation === 'vertical' ? "\n        width: 50%;\n        padding: 10px 45px;\n        position: relative;\n        text-align: center;\n        " : "\n        \n        max-width: 200px;\n        width: 200px;\n        padding: 0px 20px;\n        align-self: center;\n\n        ::after {\n            content: \"\";\n            position: absolute;\n            width: 12px;\n            height: 12px;\n            background-color: #003A3B;\n            border-radius: 50%;\n            z-index: 1;\n            top: 12px;\n        }\n        \n    ";
});
export var TimeLineContent = styled.div(_templateObject4(), function (_ref3) {
  var orientation = _ref3.orientation;
  return orientation === 'vertical' ? "\n        background-color: #ec407a;\n        padding: 18px;\n        border-radius: 4px;\n        " : "\n        min-height: 140px;\n        position: relative;\n\n    ";
});
export var Title = styled(H4)(_templateObject5(), function (_ref4) {
  var titleBold = _ref4.titleBold;
  return titleBold && 'bold';
});
export var Description = styled(Text)(_templateObject6(), function (_ref5) {
  var descriptionBold = _ref5.descriptionBold;
  return descriptionBold && 'bold';
});